import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { createTenant, fetchTenants } from "../app/actions";

import { Button, Table } from "react-bootstrap"
import AddEditTenantModal from "./AddEditTenantModal";
import { withRouter } from "react-router-dom";


const Tenants = ({history}) => {
    const [showAddEditModal, setShowAddEditModal] = useState(false)
    const tenants = useSelector(store => store.app.tenants);
    const dispatch = useDispatch();
    useEffect(()=>{
        dispatch(fetchTenants(1))
    }, [])

    const hideAddEditModal = () => {
        setShowAddEditModal(false)
    }

    const handleAddEditSave = (tenant) => {
        dispatch(createTenant(tenant.FullName, tenant.ShortName, tenant.Type, tenant.Active, tenant.Live, tenant.BusinessStatus, tenant.BusinessComment, tenant.PrimaryContact, tenant.SecondaryContact))
            .then(()=>{
                dispatch(fetchTenants(1))
                setShowAddEditModal(false)
            })
    }

    const goToTenant = id => {
        history.push("/tenants/"+id)
    }

    return <div>
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            <h2>Tenants</h2>
            {/* <Button onClick={()=>{setShowAddEditModal(true)}}>Deploy new tenant</Button> */}
        </div>
        <br/>
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Full Name</th>
                    <th>Short Name</th>
                    <th>DB_NAME</th>
                    <th>DB_HOST</th>
                    <th>Active</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>Comment</th>
                    <th>Migration Status</th>
                    <th>Updated</th>
                    <th>Created</th>
                </tr>
            </thead>
            <tbody>
                {tenants && tenants.map(tenant => {
                    return <tr key={tenant.id} onClick={() => {goToTenant(tenant.id)}}>
                        <td>{tenant.id}</td>
                        <td>{tenant.FullName}</td>
                        <td>{tenant.ShortName}</td>
                        <td>{tenant.DB_NAME}</td>
                        <td>{tenant.DB_HOST}</td>
                        <td>{tenant.Active}</td>
                        <td>{tenant.Type}</td>
                        <td>{tenant.BusinessStatus}</td>
                        <td>{tenant.BusinessComment}</td>
                        <td>
                            {tenant.MigrationStatus}
                        </td>
                        <td>{tenant.updated_at}</td>
                        <td>{tenant.created_at}</td>
                    </tr>
                })}
            </tbody>
        </Table>
        <AddEditTenantModal show={showAddEditModal} onHide={hideAddEditModal} onSave={handleAddEditSave}/>
    </div>
} 

export default withRouter(Tenants)